import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const settings = gql`
  query ChannelSettingsQuery($slug: String!) {
    channel(slug: $slug) {
      ...ChannelSettings
    }
  }

  ${Fragments.channel.settings}
`;

export const groups = gql`
  query ChannelGroupsQuery($slug: String!) {
    channel(slug: $slug) {
      ...ChannelGroups
    }
  }

  ${Fragments.channel.groups}
`;

export const unreadCounts = gql`
  query ChannelUnreadCountsQuery($slug: String!) {
    channel(slug: $slug) {
      ...ChannelUnreadCounts
    }
  }

  ${Fragments.channel.unreadCounts}
`;

export const listItem = gql`
  query ChannelListItemQuery($slug: String!) {
    channel(slug: $slug) {
      ...ChannelListItem
    }
  }

  ${Fragments.channel.listItem}
`;

export const list = gql`
  query ChannelListQuery {
    listChannels(input: {}) {
      id
      slug
      name
      workflowTemplateId
      type
      imageUrl
      description
      updatedAt
      deletedAt
      cardCount
      defaultFocus
      autoAddUsers
      visible
    }
  }
`;

// Seeds channel unread badges until listChannels can return unreadCount; see
// useSeedInitialChannelUnreadCounts in useUnreadCount.ts.
export const legacyListChannelUnreadCounts = gql`
  query LegacyListChannelUnreadCountsQuery($businessId: Int!, $filter: ChannelUnreadType) {
    legacyListChannelUnreadCounts(businessId: $businessId, filter: $filter) {
      channelId
      unreadCount
    }
  }
`;

export const deletedList = gql`
  query DeletedChannelListQuery($input: ListChannels!) {
    listChannels(input: $input) {
      ...DeletedChannel
    }
  }

  ${Fragments.channel.deletedChannel}
`;

export const listWorkspaceSections = gql`
  query ListWorkspaceSectionsQuery {
    listWorkspaceSections {
      ...WorkspaceSection
    }
  }

  ${Fragments.channel.workspaceSection}
`;

export const listV2 = gql`
  query ListChannelsQuery($input: ListChannels!) {
    listChannels(input: $input) {
      id
      type
      slug
      workflowTemplateId
      channelMemberships {
        ...ChannelMembership
      }
      visible
    }
  }

  ${Fragments.channel.membership}
`;

export const chatThread = gql`
  query ChannelChatThreadQuery(
    $slug: String!
    $since: DateTime
    $limit: Int!
    $fetchMessagesAfterSince: Boolean
  ) {
    channel(slug: $slug) {
      ...ChannelChatThread
    }
  }

  ${Fragments.channel.chatThread}
`;

export const listReports = gql`
  query ChannelListReportsQuery($input: ListReports!) {
    listReports(input: $input) {
      ...ChannelReport
    }
  }

  ${Fragments.channel.report}
`;

export const getRelatedChannelAssociations = gql`
  query RelatedChannelAssociationsQuery($id: Int!) {
    getChannel(id: $id) {
      slug
      relatedChannelAssociations {
        relatedChannelId
        field
      }
    }
  }
`;

export const getChannel = gql`
  query ChannelQuery($id: Int, $slug: String) {
    channel: getChannel(id: $id, slug: $slug) {
      ...Channel
    }
  }

  ${Fragments.channel.channel}
`;

export const listSharedCardLinks = gql`
  query ListSharedCardLinksQuery($input: ListSharedCardLinks!) {
    listSharedCardLinks(input: $input) {
      ...SharedCardLink
    }
  }

  ${Fragments.channel.sharedCardLink}
`;

export const dmChannelUsers = gql`
  query DmChannelUsersQuery($input: ListChannels!) {
    listChannels(input: $input) {
      id
      slug
      channelMemberships {
        id
        user {
          id
          fullName
          username
          imageUrl
          isMe
        }
      }
    }
  }
`;

export const listChannelMembershipsV2 = gql`
  query ListChannelMembershipsV2Query($input: ListChannelMembershipsV2!, $customCacheKey: String!) {
    listChannelMembershipsV2(input: $input) @connection(key: $customCacheKey) {
      hasMore
      totalResults
      memberships {
        ...ChannelMembershipV2
      }
    }
  }

  ${Fragments.channel.membershipV2}
`;
